import { render, staticRenderFns } from "./StatisticsTrials.vue?vue&type=template&id=3f80178c&"
import script from "./StatisticsTrials.vue?vue&type=script&lang=js&"
export * from "./StatisticsTrials.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTrials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports